export type PlanetKey =
  | 'sun' | 'moon' | 'ascendant'
  | 'mercury' | 'venus' | 'mars'
  | 'jupiter' | 'saturn' | 'uranus' | 'neptune' | 'pluto';

const FREE_PLANETS: PlanetKey[] = ['sun', 'moon', 'ascendant'];
const LOCKED_PLANETS: PlanetKey[] = ['mercury', 'venus', 'mars', 'jupiter', 'saturn', 'uranus', 'neptune', 'pluto'];

export function canAccessPlanet(key: PlanetKey, isPaid: boolean): boolean {
  if (isPaid) return true;
  return FREE_PLANETS.includes(key);
}

export function getFreePlanets(): PlanetKey[] { return FREE_PLANETS; }
export function getLockedPlanets(): PlanetKey[] { return LOCKED_PLANETS; }
